import { useState } from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarProvider,
  SidebarTrigger,
} from "@bigbinary/neeto-atoms/primitives";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import ConfigureView from "./Sidebar/Components/ConfigureView";

const ConfigurePageSidebar = ({
  label,
  navLinks: items,
  configurePageRoute,
}) => {
  const history = useHistory();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleConfigureLinkClick = () => {
    history.push(configurePageRoute);
  };

  return (
    <SidebarProvider
      className="!w-auto"
      open={!isSidebarCollapsed}
      onOpenChange={open => setIsSidebarCollapsed(!open)}
    >
      <Sidebar
        collapsible="offcanvas"
        side={document.documentElement.dir === "rtl" ? "right" : "left"}
      >
        <SidebarContent>
          <ConfigureView
            isConfigureSidebar
            handleGoBack={handleConfigureLinkClick}
            navLink={{ label, items }}
          />
        </SidebarContent>
      </Sidebar>
      <SidebarTrigger />
    </SidebarProvider>
  );
};

ConfigurePageSidebar.propTypes = {
  configurePageRoute: PropTypes.string,
  label: PropTypes.string,
  navLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      to: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({ label: PropTypes.string, to: PropTypes.string })
      ),
    })
  ),
};

export default ConfigurePageSidebar;
